import type { GetBrandDto } from '@api/machines'
import {
  MolsonBox,
  MolsonGrid,
  MolsonIcon,
  MolsonTextField
} from '@components/reusable'
import debounce from 'lodash.debounce'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BrandCard } from '../brand-card/BrandCard'

type SelectBrandStepV2Props = {
  brands?: GetBrandDto[]
  translationPrefix?: string
  setSelectedBrand: (brand: GetBrandDto) => void
  selectedBrand?: GetBrandDto | null
}

export const SelectBrandStepV2 = ({
  brands = [],
  translationPrefix,
  setSelectedBrand,
  selectedBrand
}: SelectBrandStepV2Props) => {
  const { t } = useTranslation('', {
    keyPrefix: translationPrefix ?? 'common'
  })

  const [filteredBrands, setFilteredBrands] = useState<GetBrandDto[]>(brands)

  const filterBrands = useMemo(
    () =>
      debounce(
        (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
          if (!e.target.value) {
            return setFilteredBrands(brands)
          }

          setFilteredBrands(
            brands?.filter((brand: GetBrandDto) =>
              brand.name
                ?.toLowerCase()
                .includes(e.target.value.toLowerCase().trim())
            )
          )
        },
        300
      ),
    [brands]
  )

  return (
    <>
      <MolsonBox display="flex" justifyContent="end" mb={1.5}>
        <MolsonTextField
          iconStart={<MolsonIcon variant="SEARCH_MAGNIFY" iconColor="ghost" />}
          onChange={filterBrands}
          placeholder={t('search') ?? ''}
        />
      </MolsonBox>
      <MolsonGrid container={true} spacing={3}>
        {filteredBrands?.map((brand: GetBrandDto) => (
          <MolsonGrid
            item={true}
            key={brand.id}
            md={4}
            onClick={() => setSelectedBrand(brand)}
            sm={6}
            xs={12}
          >
            <BrandCard
              brand={brand.name as string}
              logo={brand.logo as string}
              selected={brand.id === selectedBrand?.id}
            />
          </MolsonGrid>
        ))}
      </MolsonGrid>
    </>
  )
}
